<template>

<app-wrapper>

	<app-banner />

	<com-filter v-on:change="onFilterChange" />

	<com-feed :items="feed" :loading="loading" />

	<com-paginate v-if="total > feed.length" :current="page" :total="total" v-on:click="onPaginate" :loading="loading" />

</app-wrapper>

</template>

<script>

import Vue from 'vue'

export default {

	components: {

		'com-filter': () => import('./news/Filter'),
		'com-feed': () => import('./news/Feed'),
		'com-paginate': () => import('./news/Paginate')

	},

	data: function() {

		return {
			loading: true,
			feed: [],
			filter: {
				type: [1,2,3],
				topic: false
			},
			page: 1,
			total: 0
		}

	},

	computed: {

		topic: function() {

			return this.$route.query.topic

		}

	},

	watch: {

		topic: function(n) {

			if (n) this.load()

		}

	},

	created: function() {

		this.load()

	},

	methods: {

		onPaginate: function(index) {

			this.page = index

			this.load()

		},

		onFilterChange: function(filter) {

			Vue.set(this, 'filter', filter)

			this.page = 1
			this.feed = []
			this.total = 0

			this.load()

		},

		load: function() {

			this.loading = true

			this.$api.get('feed', {
				type: this.filter.type,
				search: this.$route.query.topic,
				page: this.page
			}).then(function(json) {

				this.feed = json.feed
				this.total = json.total

				this.loading = false

			}.bind(this))

		}

	}

}

</script>

<style scoped>

</style>
